/* lua.js generated code undefined */

require("clover/panel/component/common/UIGroupButton")

let ManualLocationExplainPanel = xClass("ManualLocationExplainPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})
let RES = table(
  
)
ManualLocationExplainPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}
let _instance = null
ManualLocationExplainPanel.getInstance = function () {
    let self = this
    return _instance
}
ManualLocationExplainPanel.prototype.ctor = function (data) {
    let self = this
    // super 
    // BasePanel.ctor(self)
    BasePanel.prototype.ctor.call(self);
    _instance = self

    self.initUI();
}
ManualLocationExplainPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    // BasePanel.onClose(self, callback)
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

}
ManualLocationExplainPanel.prototype.onCleanup = function () {
    let self = this
    // ref 
    _instance = null
    beforeClose(self);
    ResManager.release(RES);
    // FrameLoader.unloadImageWithPlists(RES, true)
    // cc.Director.getInstance().getTextureCache().removeUnusedTextures()
}
/**
 * 关闭前的操作
 * 关闭一些动画、定时操作
 * @param {*} self 
 */
function beforeClose(self) {}

ManualLocationExplainPanel.prototype.initUI = function () {
    
    let self = this

    self.mainNode = cc.CSLoader.createNode("cocos/location_manual_explain.csb")
    self.addChild(self.mainNode);

    this.btnClose = self.mainNode.getChildByName("notice_btn_close");
    // this.btnClose.setVisible(false)
    quickBuildBtn(this.btnClose, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
    }, true);
    

    // 初始化列表
    let container = self.mainNode.getChildByName("container");
    let scrollView = ccui.ScrollView.create()
    scrollView.setAnchorPoint(0.5,0.5)
    scrollView.setDirection(ccui.ScrollViewDir.vertical)
    scrollView.setContentSize(container.width + 50, container.height)
    scrollView.setClippingEnabled(true)
    scrollView.setBounceEnabled(true)
    self.scrollView = scrollView
    this.addChild(scrollView)

    scrollView.x = container.x;
    scrollView.y = container.y;
    self.showListUI()
}

ManualLocationExplainPanel.prototype.showListUI = function () {
    let locationConfig = MetaManager.getManualLocationConfig()
    let targetHeight = 0
    let offset = 20
    let contentStr = getText("positionSwitch.instruction.text")
    let contentArr = contentStr.split("&&")
    for (var i = 0; i < contentArr.length; i++) { 
        let str = contentArr[i].replace("{day}", locationConfig.location_set_cd_days)
        let textTip = cc.LabelTTF.create(str, null, 23);
        textTip.setColor(cc.c4b(122, 51, 32, 255))
        textTip.setDimensions(400, 0)
        textTip.setAnchorPoint(0,1)
        // textTip.setLineHeight(40)
        textTip.x = 20
        this.scrollView.addChild(textTip)
        targetHeight = targetHeight + textTip.height + offset
        // textTip.y = this.scrollView.getInnerContainerSize().height -textTip.height*i
    }
    
    targetHeight = targetHeight > this.scrollView.height ? targetHeight : this.scrollView.height
    this.scrollView.setInnerContainerSize(cc.size(this.scrollView.width, targetHeight))

    let onH = 5
    for (let i = 0; i < this.scrollView.getChildren().length; i++) {
       let node = this.scrollView.getChildren()[i]
       node.y = this.scrollView.getInnerContainerSize().height -onH
       onH += node.height + offset
    }
}
module.exports = ManualLocationExplainPanel